import React from 'react';
import RequestsTableSC from './requests-table.styled';
import { ReactComponent as FileIcon } from '../../../assets/img/svg/pdf.svg';
import { BodyText, SmallText } from '../../typography';
import Moment from 'react-moment';
import { FormattedMessage } from 'react-intl';
import dlt from '../../../utils/default-lang';
import { LS_ACCESS_TOKEN } from '../../../constants';
import { EmptySC } from '../../investor-mailbox-content/investor-mailbox-content.styled';

const RequestsTable = ({ requests }) => {
  const onReqClick = (reqLink) => {
    window.open(
      `${process.env.REACT_APP_WISHMAKER_API_URI}${
        process.env.REACT_APP_DOC_SLUG
      }/${reqLink}?token=${localStorage.getItem(LS_ACCESS_TOKEN)}`
    );
  };

  if (requests.length < 1) {
    return (
      <EmptySC>
        <div className="empty-table">
          <SmallText className="black-transparent bold">
            <FormattedMessage
              id="mailbox_requests_empty"
              defaultMessage={dlt['mailbox_requests_empty']}
            />
          </SmallText>
        </div>
      </EmptySC>
    );
  }

  return (
    <RequestsTableSC>
      {requests.map((req) => {
        return (
          <div key={req.id} className="req-wrap">
            <button onClick={() => onReqClick(req.document.url)}>
              <span className="req-icon">
                <FileIcon />
              </span>
              <div className="req-info-wrap">
                <span className="req-name">
                  <BodyText>
                    <FormattedMessage
                      id={`mailbox_requests_${req.type}`}
                      defaultMessage={dlt[`mailbox_requests_${req.type}`]}
                    />
                  </BodyText>
                </span>
                <span className="req-date">
                  <BodyText className="black-transparent">
                    <Moment format="DD. MMMM YYYY">{req.created_at}</Moment>
                  </BodyText>
                  <BodyText className="black-transparent">
                    <Moment format="HH:mm">{req.created_at}</Moment>
                  </BodyText>
                </span>
              </div>
            </button>
          </div>
        );
      })}
    </RequestsTableSC>
  );
};

export default RequestsTable;
